import { ReactNode } from 'react'

import {
  Text,
  GreyGrey80,
  Primary14SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { match } from 'ts-pattern'

type Props = {
  title?: string
  titleSpacing?: 'small' | 'normal'
  children: ReactNode
}

export const StepSection = ({
  title,
  children,
  titleSpacing = 'normal'
}: Props) => (
  <Box>
    {title && (
      <Text
        {...Primary14SemiBold}
        color={GreyGrey80}
        marginBottom={match(titleSpacing)
          .with('small', () => '8px')
          .with('normal', () => '16px')
          .exhaustive()}
      >
        {title}
      </Text>
    )}

    <Flex flexDir="column" gap="16px">
      {children}
    </Flex>
  </Box>
)
